// extracted by mini-css-extract-plugin
module.exports = {"singleBlogPostContainer":"blog-post-carousel_singleBlogPostContainer__2R9g8"};